import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonGroupModule, DxChartModule, DxPivotGridModule, DxSelectBoxModule, DxToolbarModule } from 'devextreme-angular';
import { FieldsInterventionsPivotGridComponent } from './fields-interventions-pivot-grid.component';
import { FieldsInterventionsFuelConsumptionPerOperationReportModule } from './reports/fields-interventions-fuel-consumption-per-operation-report/fields-interventions-fuel-consumption-per-operation-report.module';
import { FieldsInterventionsGeneralIIReportModule } from './reports/fields-interventions-general-ii-report/fields-interventions-general-ii-report.module';
import { FieldsInterventionsGeneralReportModule } from './reports/fields-interventions-general-report/fields-interventions-general-report.module';
import { FieldsInterventionsOperationsProgressReportModule } from './reports/fields-interventions-operations-progress-report/fields-interventions-operations-progress-report.module';
import { FieldsInterventionsSpeedPerOperationTrailerReportModule } from './reports/fields-interventions-speed-per-operation-trailer-report/fields-interventions-speed-per-operation-trailer-report.module';
import { FieldsInterventionsThroughputPerOperationTrailerReportModule } from './reports/fields-interventions-throughput-per-operation-trailer-report/fields-interventions-throughput-per-operation-trailer-report.module';
import { FieldsInterventionsTimeRepartitionReportModule } from './reports/fields-interventions-time-repartition-report/fields-interventions-time-repartition-report.module';
import { FieldsInterventionsTractorsSpeedWorkingAreaTimeReportModule } from './reports/fields-interventions-tractors-speed-working-area-time-report/fields-interventions-tractors-speed-working-area-time-report.module';
import { FieldsInterventionsTractorsTrailerWidthChoiceReportModule } from './reports/fields-interventions-tractors-trailer-width-choice-report/fields-interventions-tractors-trailer-width-choice-report.module';
import { FieldsInterventionsTractorUsageReportModule } from './reports/fields-interventions-tractors-usage-report/fields-interventions-tractors-usage-report.module';


@NgModule({
  declarations: [FieldsInterventionsPivotGridComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxButtonGroupModule,
    DxChartModule,
    FieldsInterventionsSpeedPerOperationTrailerReportModule,
    FieldsInterventionsGeneralReportModule,
    FieldsInterventionsOperationsProgressReportModule,
    FieldsInterventionsThroughputPerOperationTrailerReportModule,
    FieldsInterventionsTimeRepartitionReportModule,
    FieldsInterventionsTractorsTrailerWidthChoiceReportModule,
    FieldsInterventionsTractorUsageReportModule,
    FieldsInterventionsFuelConsumptionPerOperationReportModule,
    FieldsInterventionsGeneralIIReportModule,
    FieldsInterventionsTractorsSpeedWorkingAreaTimeReportModule
  ],
  exports: [FieldsInterventionsPivotGridComponent]
})
export class FieldsInterventionsPivotGridModule { }
